<template>
  <div class="innerBox">
    <h2 class="mb-4">Role Management</h2>

    <vue-universal-table
      api_url="/api/v1/roles/permissions"
      :update="vue_universal_table.update"
      :fields="vue_universal_table.fields"
      :buttons="vue_universal_table.buttons"
      :special_buttons="vue_universal_table.special_buttons"
      @onPeranBaru="modal.new = true"
      @onEdit="edit"
      @onDelete="deleteRole"
    ></vue-universal-table>

    <new-role
      v-if="modal.new"
      @closeModal="modal.new = false"
      @updateTable="vue_universal_table.update++"
    ></new-role>

    <edit-role
      v-if="modal.edit"
      :editData="editData"
      @closeModal="modal.edit = false"
      @updateTable="vue_universal_table.update++"
    ></edit-role>

  </div>
</template>

<script>
  import newRole from './children/newRole'
  import editRole from './children/editRole'

  export default {
    data () {
      return {
        modal : {
          new : false,
          edit : false,
        },
        data : null,
        vue_universal_table : {
          update : 0,
          special_buttons : ['peranBaru'],
          buttons : [
            {
              title : 'Edit',
              class : 'btn-outline-primary fa fa-edit'
            },
            {
              title : 'Delete',
              class : 'btn-outline-danger fa fa-times'
            }
          ],
          fields : [
            {
              title : 'ID',
              variable : 'id'
            },
            {
              title : 'Nama Role',
              variable : 'name'
            },
            {
              title : 'Dibuat Pada',
              variable : 'created_at'
            }
          ]
        },
        editData : null,
      }
    },
    components : {
      newRole,
      editRole,
    },
    mounted () {
      this.generateData()
    },
    methods : {
      generateData(){
        this.data = [
          {
            role_id : 1,
            role_name : 'Bartender',
            created_at : '10-02-1990 12:05:12'
          },
          {
            role_id : 2,
            role_name : 'Mechanist',
            created_at : '01-07-2011 13:12:25'
          },
          {
            role_id : 3,
            role_name : 'Administrator',
            created_at : '03-11-2018 15:20:30'
          }
        ]
      },
      edit(x){
        x = JSON.parse(x)
        if(x.name == 'Warna' || x.name == 'Tanda Terima Only') {
          this.$store.dispatch('triggerAlert' , [false , 'Role Tersebut Spesial. Tidak bisa di edit.'])
          return;
        }
        this.editData = x
        this.modal.edit = true;
      },
      deleteRole(x){
        x = JSON.parse(x)
        if(x.name == 'Warna' || x.name == 'Tanda Terima Only') {
          this.$store.dispatch('triggerAlert' , [false , 'Role Tersebut Spesial. Tidak bisa di delete.'])
          return;
        }

        this.$http.delete(`/api/v1/roles/${x.id}`)
        .then((resp)=>{
          this.$store.dispatch('triggerAlert', [true, resp.data.data])
          this.vue_universal_table.update++;
        })
        .catch((err)=>{console.log(err.response.data.message)})
      }
    }
  }
</script>

<style scoped>
  
</style>